import { useLanguage } from '@/i18n/LanguageContext';

const customers = [
  { 
    name: 'National Library of Latvia', 
    logo: 'https://customer-assets.emergentagent.com/job_industrial-iot-4/artifacts/wn5z0hwl_National%20Library%20of%20Latvia.png'
  },
  { 
    name: 'Rigas Siltums', 
    logo: 'https://customer-assets.emergentagent.com/job_industrial-iot-4/artifacts/4xwo615a_Rigas%20Siltums.jpg'
  },
  { 
    name: 'RIX Airport', 
    logo: 'https://customer-assets.emergentagent.com/job_industrial-iot-4/artifacts/k7lo5nkl_RIX.png'
  },
  { 
    name: 'Sadales Tikls', 
    logo: 'https://customer-assets.emergentagent.com/job_industrial-iot-4/artifacts/pkxviia0_Sadales%20Tikles.jpg'
  },
  { 
    name: 'Virsi', 
    logo: 'https://customer-assets.emergentagent.com/job_industrial-iot-4/artifacts/hj6gic4x_Virsi.png'
  },
  { 
    name: 'Energodati', 
    logo: 'https://customer-assets.emergentagent.com/job_industrial-iot-4/artifacts/sqwmju7t_Data%20Mining%20Solutions.png'
  },
  { 
    name: 'Latvenergo', 
    logo: 'https://customer-assets.emergentagent.com/job_industrial-iot-4/artifacts/o9ue1gyf_Latvenergo_logo_jpg.jpg'
  },
  { 
    name: 'Jelgava Municipality', 
    logo: 'https://customer-assets.emergentagent.com/job_industrial-iot-4/artifacts/lwogtavl_Jelgava%20Municipality.svg'
  },
  { 
    name: 'Benu Aptieka', 
    logo: 'https://customer-assets.emergentagent.com/job_industrial-iot-4/artifacts/yi10dwv2_Benu%20Aptieka.png'
  },
  { 
    name: 'City of Riga', 
    logo: 'https://customer-assets.emergentagent.com/job_industrial-iot-4/artifacts/jv5yfqb9_City%20of%20Riga.svg'
  },
];

export const CustomersSection = () => {
  const { t } = useLanguage();

  return (
    <section className="py-16 md:py-20 bg-slate-900" data-testid="customers-section">
      <div className="container-0g mb-8">
        <div className="text-center">
          <p className="text-xs font-bold uppercase tracking-widest text-teal-400 mb-2">{t('customers.label')}</p>
          <h2 className="text-2xl md:text-3xl font-semibold tracking-tight text-white">{t('customers.title')}</h2>
        </div>
      </div>

      {/* Logo Marquee */}
      <div className="relative overflow-hidden">
        {/* Gradient masks */}
        <div className="absolute left-0 top-0 bottom-0 w-32 bg-gradient-to-r from-slate-900 to-transparent z-10" />
        <div className="absolute right-0 top-0 bottom-0 w-32 bg-gradient-to-l from-slate-900 to-transparent z-10" />
        
        {/* Scrolling container */}
        <div className="flex animate-marquee">
          {/* First set of logos */}
          {customers.map((customer, index) => (
            <div 
              key={`first-${index}`}
              className="flex-shrink-0 mx-8 flex items-center justify-center bg-white rounded-sm px-8 py-4 min-w-[200px] h-24"
            >
              <img 
                src={customer.logo} 
                alt={customer.name}
                className="max-h-16 max-w-[160px] object-contain"
              />
            </div>
          ))}
          {/* Duplicate for seamless loop */}
          {customers.map((customer, index) => (
            <div 
              key={`second-${index}`}
              className="flex-shrink-0 mx-8 flex items-center justify-center bg-white rounded-sm px-8 py-4 min-w-[200px] h-24"
            >
              <img 
                src={customer.logo} 
                alt={customer.name}
                className="max-h-16 max-w-[160px] object-contain"
              />
            </div>
          ))}
          {/* Third set for longer scroll */}
          {customers.map((customer, index) => (
            <div 
              key={`third-${index}`}
              className="flex-shrink-0 mx-8 flex items-center justify-center bg-white rounded-sm px-8 py-4 min-w-[200px] h-24"
            >
              <img 
                src={customer.logo} 
                alt={customer.name}
                className="max-h-16 max-w-[160px] object-contain"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
